import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { ScreenType } from 'src/app/enums/ScreenType';

@Component({
  selector: 'app-date-time-picker',
  templateUrl: './date-time-picker.component.html',
  styleUrls: ['./date-time-picker.component.scss'],
})
export class DateTimePickerComponent implements AfterViewInit {
  @ViewChild('DateTimePicker') getDimension: any;
  @Output() calendarDimensions = new EventEmitter();
  @Output() dateTimeSlot = new EventEmitter();
  @Output() addNewVisitor = new EventEmitter();
  @Output() selectedDate = new EventEmitter();
  @Input() set screen(val: ScreenType) {
    this.screenInfo = val;
  }
  firstFormGroup = this._formBuilder.group({
    firstCtrl: ['', Validators.required],
  });
  secondFormGroup = this._formBuilder.group({
    secondCtrl: ['', Validators.required],
  });
  screenInfo: ScreenType;
  calDimensions: { height: any; width: any };
  fixedDimensions: { height: any; width: any };
  calendarHeight: any;
  selectDate: Date;
  todayDateNotTime = new Date();
  selectDateNotTime: Date;
  temp1: number;
  temp2: number;
  isTimeSlotSelected = false;

  constructor(private _formBuilder: FormBuilder) {}
  ngAfterViewInit(): void {
    setTimeout(() => {
      this.calDimensions = {
        height: this.getDimension.nativeElement.offsetHeight,
        width: this.getDimension.nativeElement.offsetWidth,
      };
      this.fixedDimensions = {
        height: this.getDimension.nativeElement.offsetHeight.valueOf() + 'px',
        width: this.getDimension.nativeElement.offsetWidth.valueOf() + 'px',
      };
      this.calendarDimensions.emit(this.calDimensions);
      this.selectDateNotTime = this.selectDate;
      this.todayDateNotTime.setHours(0, 0, 0, 0);
      this.selectDateNotTime.setHours(0, 0, 0, 0);
      this.temp1 = this.selectDateNotTime.getTime();
      this.temp2 = this.todayDateNotTime.getTime();
    });
  }
  getCalendarDimensions(val: any) {
    this.calendarHeight = val;
  }
  getSelectedDate(val: Date) {
    this.selectDate = val;
    this.selectDateNotTime = val;
    this.temp1 = new Date(this.selectDateNotTime).getTime();
    this.selectedDate.emit(this.selectDate);
  }
  getDateTimeSlot(val: Date) {
    this.dateTimeSlot.emit(val);
    this.isTimeSlotSelected = true;
  }
  goBack(stepper: MatStepper) {
    stepper.previous();
  }
  goNext(stepper: MatStepper) {
    stepper.next();
  }
  onAddNewVisitor() {
    this.addNewVisitor.emit();
  }
  ScreenType = ScreenType;
}
